<template>
  <div class="login shareIndex">
    <div class="text-center">{{showtext}}</div>
  </div>
</template>

<script>
import Vue from "vue";
import Alert from "../components/Alert";
import { List } from "vant";
import config from "@/config";
Vue.use(List);
export default {
  name: "login",
  data() {
    return {
      errorcode: 0,
      showtext: "正在登录...",
      loop: 6
    };
  },
  methods: {
    //获得微信授权
    getAuthorizationUrl() {
      var t = this;
      // var url = window.location.href;
      // console.log("window.location",window.location)
      // if (url.lastIndexOf("?") >= 0) {
      //   url = url.substring(0, url.lastIndexOf("?"));
      // }
      // var myurl = `${url}?a=${t.urlData.a}`;
      var params = {
        redirect_url: `${window.location.origin}${window.location.pathname}#/wxloginresult?errcode=0`
      };
      t._activity("activity", "Activity.getAuthorizationUrl", params)
        .then(res => {
          if (res.status == 0) {
            window.location.href = res.data.code_url.body;
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },

    // app内登录
    appLogin() {
      console.log("####LU:app login");
      var t = this;
      // var url = window.location.href;
      // if (url.lastIndexOf("?") >= 0) {
      //   url = url.substring(0, url.lastIndexOf("?"));
      // }
      // var myurl = `${url}?a=${t.urlData.a}`;
      var params = {
        auth_token: t.urlData.auth_token
      };
      t._activity("wuyou", "WuyouApp.appLogin", params)
        .then(res => {
          if (res.status == 0) {
            var rep = res.data;
            var app_login_user = {
              sessionkey: rep.sessionkey,
              userid: "",
              auth: 1,
              mobile: t.urlData.mobile
            };
            localStorage.setItem(
              config.login_key,
              JSON.stringify(app_login_user)
            );
            var login_redirect = localStorage.getItem("login_redirect");
            console.log("login_redirect");
            console.log(login_redirect);
            // var login_redirect = window.location.href;
            if (login_redirect) {
              login_redirect = JSON.parse(login_redirect);
              if (login_redirect.query.clear) login_redirect.query.clear = 0;
              // localStorage.removeItem("login_redirect");
              // localStorage.removeItem(login_redirect);
              t.$router.push({
                path: login_redirect.path,
                query: login_redirect.query
              });
            } else {
              t.$router.push({
                path: "/"
              });
            }
          } else {
            t.showtext = "身份验证失败";
            // t.$toast(res.)
          }
        })
        .catch(error => {
          console.log(`error:${error}`);
        });
    },

    // 获取tId(即auth_token),oId,m
    getUserInfo(callback) {
      var t = this;
      var loading = t.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        mask: true,
        message: "加载中..."
      });
      var apiurl = `${t.baseurl2}/api/ls/v1/destination/getUserInfo`;
      var params = {
        token: t.urlData.token
      };
      t.$http
        .post(apiurl, params)
        .then(res => {
          console.log(`${apiurl},params:`, params);
          console.log(`${apiurl},res:`, res);
          loading.clear();
          if (res.data.code == 0) {
            t.userinfo = res.data.body;
            t.urlData.auth_token = t.userinfo.tId;
            callback(null, t.userinfo);
          } else {
            callback(res.data.msg);
            t.$toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error);
          callback(error);
        })
        .finally(() => {});
    },

    keyUrl() {
      var items = [];
      var url = location.href;
      if (url === undefined || typeof url != "string") {
        return null;
      }
      var json = {};
      var newurl = url.split("#")[0];
      var arr = newurl.split("?");
      if (arr.length > 1) {
        items = arr[1].split("&");
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i].split("=");
          json[item[0]] = item[1];
        }
      }
      return json;
    },

    initData(callback) {
      var t = this;
      console.log("login:window load-----------");
      console.log(window.location.href);
      // t.urlData = t.keyUrl();
      t.urlData = t.$route.query;
      // if (q.a) {
      //   t.urlData = q;
      // }
      // if (t.urlData.a) {
      //   Vue.prototype.activityId = t.urlData.a;
      // }
      console.log("t.urlData:", t.urlData);
      // 因为app内报错JegoOnload该无忧行的方法，峰说用一下这个方法
      try {
        console.log("Jegotrip.JegoOnload()");
        Jegotrip.JegoOnload();
      } catch (e) {
        console.log(e);
      }
      try {
        JegoOnload();
      } catch (e) {
        console.log(e);
      }

      setTimeout(function() {
        var userInfo = "";
        try {
          userInfo = Jegotrip.getUserInfo();
        } catch (e) {}

        console.log("userInfo:Jegotrip.getUserInfo()");
        console.log(userInfo);
        console.log("t.urlData:", t.urlData);
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
          t.urlData.token = userInfo.token;
          t.urlData.mobile = userInfo.mobile;
          t.urlData.userId = userInfo.userCode;
          typeof callback == "function" && callback();
        } else {
          // loading.clear();
          if (t.loop < 3) {
            t.loop++;
            console.log("循环请求次数：" + t.loop);
            t.initData(callback);
          } else {
            t.loop = 0;
            typeof callback == "function" && callback("no token");
          }
        }
        // t.getteams(t.urlData.token, t.urlData.openid);
        // t.getTeamAwards(t.urlData.openid);
      }, 200 + t.loop * 200);
    }
  },
  components: {
    Alert
  },
  computed: {},
  created() {
    // var t = this;
    // t.urlData = t.$route.query;
    // console.log("***t.urlData-app***:", t.urlData);
    // console.log("***window.location.href***:", window.location.href);
    // //无忧行APP内授权
    // if (navigator.userAgent.indexOf("jegotrip") > -1 || t.urlData.auth_token) {
    //   if (t.urlData.auth_token) t.appLogin();
    //   else {
    //     t.errorcode = 2;
    //     t.showtext = "错误，无法获得临时令牌！";
    //   }
    // }
    // //微信内容授权
    // else t.getAuthorizationUrl();
  },
  mounted() {
    var t = this;
    // t.urlData = t.$route.query;

    console.log("***login:window.location.href***:", window.location.href);
    //无忧行APP内授权
    if (
      navigator.userAgent.indexOf("jegotrip") > -1 ||
      (t.urlData && t.urlData.auth_token)
    ) {
      t.initData(() => {
        console.log("***login:t.urlData***:", t.urlData);
        if (t.urlData.auth_token) t.appLogin();
        else {
          if (!t.urlData.token || t.urlData.token == "") {

            t.$dialog
              .alert({
                message: "您的奖励已到账，快去领取吧",
                confirmButtonText: "去领取"
              })
              .then(() => {
                window.location.reload();
              });
            try {
              console.log('尝试调起无忧行登录页面')
              Jegotrip.userLogin();
              return false;
            } catch (e) {}

            t.errorcode = 2;
            t.showtext = "您未登录，请登录后重新打开页面";
          } else {
            t.getUserInfo(function(err, user) {
              if (!err) {
                t.urlData.auth_token = user.tId;
                t.appLogin();
              }
            });
          }
        }
      });
    }
    //微信内容授权
    else t.getAuthorizationUrl();
  }
};
</script>

<style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>



<!-- Add "scoped" attribute to limit CSS to this component only -->
